// 物語ドキュメント駆動モード（F13〜F16）共通ヘルパー（設定読込・テンプレート・ID 正規化）
import path from 'node:path';
import { CONFIG_DIR } from './repo-paths.mjs';
import { readJson } from './json-utils.mjs';
import { normalizeConcurrency } from './async-pool.mjs';

let cachedPipeline = null;

export function pipelineConfig() {
    if (!cachedPipeline) cachedPipeline = readJson(path.join(CONFIG_DIR, 'story-pipeline.json'));
    return cachedPipeline;
}

/** 一括実行時のキャスト同時実行数。無効時・設定不正時は逐次実行にする。 */
export function batchCharacterConcurrency(stage, enabled = false) {
    if (!enabled) return 1;
    return normalizeConcurrency(pipelineConfig().batchExecution?.[stage]?.maxConcurrentCharacters);
}

/**
 * 行配列 or 文字列のテンプレートに {name} プレースホルダを埋める。
 * 未定義の変数はそのまま残す（JSON 例中の波括弧は \w+ 単独でないため誤置換されない）。
 */
export function fillTemplate(lines, vars = {}) {
    const text = Array.isArray(lines) ? lines.join('\n') : String(lines);
    return text.replace(/\{(\w+)\}/g, (match, key) => (vars[key] !== undefined ? String(vars[key]) : match));
}

/** 任意の文字列を英小文字 snake_case の ASCII ID に正規化する（不能なら fallback）。 */
export function toSnakeId(value, fallback) {
    const s = String(value ?? '')
        .normalize('NFKC')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/^(\d)/, 'x$1');
    return /^[a-z][a-z0-9_]*$/.test(s) ? s.slice(0, 48) : fallback;
}

export const str = (v) => (typeof v === 'string' ? v.trim() : v == null ? '' : String(v).trim());
export const asArray = (v) => (Array.isArray(v) ? v : []);
